import { LUCID_RUN_PROMPT } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type Response = {
    text: string;
    is_eof: true;
    tokens: {
        input: 4648;
        index: 934;
    };
};

export default async (params: {
    pt_oid: string;
    input_variables: {
        curr_date: string;
    };
    ipd_id: string;
    docid: string;
}): Promise<Response> => {
    const response = await fetchWithRefresh(LUCID_RUN_PROMPT, {
        method: 'POST',
        headers: {
            Accept: 'text/event-stream',
            'Content-Type': 'application/json',
            'jwt-payload': JSON.stringify({ oid: params.docid }),
        },
        body: JSON.stringify({
            prompt_id: 'bright-eagle-559',
            system_prompt_id: 'happy-dolphin-529',
            model: 'anthropic.claude-3-5-sonnet-20240620-v1:0',
            use_patient_data: true,
            data_source: 'doctool',
            ...params,
        }),
    });

    if (!response.body) {
        throw new Error('Readable stream not supported!');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let lastEvent = null;

    while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });

        // Split by lines and process each event
        const events = chunk.split('\n');
        for (const line of events) {
            if (line.startsWith('data:')) {
                lastEvent = line.slice(5).trim();
            }
        }
    }

    return JSON.parse(lastEvent || '{}');
};
